import { render, staticRenderFns } from "./BudgetAccountEdit.vue?vue&type=template&id=2bb9d017&scoped=true&"
import script from "./BudgetAccountEdit.vue?vue&type=script&lang=js&"
export * from "./BudgetAccountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9d017",
  null
  
)

export default component.exports